import { BaseClient } from '../base-client';
import type { TimesheetSettings, UpdateTimesheetSettingsInput } from './types';

type SettingsResponse = { data: TimesheetSettings };

export class TimesheetSettingsClient extends BaseClient {
  /** The tenant's timesheet lock settings. The API returns computed
   *  defaults (no auto-lock) when none have been saved yet. */
  get(): Promise<SettingsResponse> {
    return this.request('/api/timesheet-settings');
  }

  /** Create or replace the tenant's timesheet lock settings. */
  update(input: UpdateTimesheetSettingsInput): Promise<SettingsResponse> {
    return this.request('/api/timesheet-settings', { method: 'PUT', body: input });
  }
}
